import React, { useEffect, useRef, useState } from 'react';

import { useMedia } from 'react-use';
import userService from '../services/UserService';
import { showToast } from '../shared/Toast';
import { isExpired, isUndefinedNullEmpty, OptionProps, SbCurrentUser } from '../submission_boards/component/SbModel';
import Button from '../submission_boards/component/Button';
import { CheckIcon, CircleCheckBigIcon, ClockFadingIcon, InfoIcon, Key, Minus } from 'lucide-react';
import { BillingCycle, isDownGradeUserPlan, MasterPlan, SubscriptionTier, UserPlan } from './UserPlanModal';
import DowngradePlanPage from './DowngradePlan';
import Breadcrumb2 from '../shared/Breadcrumb2';
import { Switch } from '@headlessui/react';
import { twMerge } from 'tailwind-merge';
import SelectCombobox from '../submission_boards/component/SelectCombobox';
import { useIsMobile } from '../submission_boards/component/useIsMobile';
import Tooltip from '../shared/Tooltip';
import ContactSales from './ContactSales';
import SelectList from '../submission_boards/component/SelectList';

interface UserPlansPageProps {
  currentUser: SbCurrentUser;
  contact_btn: number;
  is_pro_trial: boolean;
  is_premium_trial: boolean;
}

export default function UserPlansPage({
  currentUser,
  contact_btn,
  is_pro_trial,
  is_premium_trial,
}: UserPlansPageProps) {
  const is400_639Screen = useMedia('(min-width: 400px) and (max-width: 639px)', false);
  const isMobile = useIsMobile(); // Hook is used here

  const [showSubscriptionTiersContactSales, setshowSubscriptionTiersContactSales] = useState<string[]>([]);
  const [masterPlans, setMasterPlans] = useState<MasterPlan[]>([]);
  const [userPlans, setUserPlans] = useState<UserPlan[]>([]);
  const [monthlyYearly, setmonthlyYearly] = useState<string>(BillingCycle.year);
  const [expandKeyFeature, setExpandKeyFeature] =  useState('')
  const [expandComing, setExpandComing] =  useState('')
  const [compareOptionA, setcompareOptionA] =  useState<OptionProps|null>(null);
  const [compareOptionB, setcompareOptionB] =  useState<OptionProps|null>(null);
  const [masterPlanA, setmasterPlanA] =  useState<MasterPlan|null>(null);
  const [masterPlanB, setmasterPlanB] =  useState<MasterPlan|null>(null);

  const [featuresNames, setfeaturesNames] = useState(
    
[{tier_compare:['free','pro','pro_idle','premium','archive','enterprise'],tier:['free'], name:"Access to Basic level", coming: false},
{tier_compare:['free','pro','pro_idle','premium','archive','enterprise'],tier:['free'], name:"Talent data and profile", coming: false},
{tier_compare:['free','pro','pro_idle','premium','archive','enterprise'],tier:['free'], name:"Talent Kits", coming: false},
{tier_compare:['free','pro','pro_idle','premium','archive','enterprise'],tier:['free'], name:"Basic level media", coming: false},

{tier_compare:['pro','pro_idle','premium','archive','enterprise'],tier:['pro','pro_idle'], name:"Premium Visual Branding", coming: false },
{tier_compare:['pro','pro_idle','premium','archive','enterprise'],tier:['pro','pro_idle'], name:"Prioritized Search Results", coming: false },
{tier_compare:['pro','pro_idle','premium','archive','enterprise'],tier:['pro','pro_idle'], name:"Enhanced Media Integration", coming: false },
{tier_compare:['pro','pro_idle','premium','archive','enterprise'],tier:['pro','pro_idle'], name:"Professional Connectivity", coming: false },
{tier_compare:['pro','pro_idle','premium','archive','enterprise'],tier:['pro','pro_idle'], name:"Enhanced Photo Management", coming: false },
{tier_compare:['pro','pro_idle','premium','archive','enterprise'],tier:['pro','pro_idle'], name:"Dedicated Looks and Submissions", coming: false },

{tier_compare:['pro','pro_idle','premium','archive','enterprise'],tier:['pro'], name:"Advanced Skill Ratings", coming: true },
{tier_compare:['pro','pro_idle','premium','archive','enterprise'],tier:['pro'], name:"Access to \"Hustle\" Features", coming: true },
{tier_compare:['pro','pro_idle','premium','archive','enterprise'],tier:['pro'], name:"Profile Analytics", coming: true },
{tier_compare:['pro','pro_idle','premium','archive','enterprise'],tier:['pro'], name:"Availability Calendar", coming: true },

{tier_compare:['pro','pro_idle','premium','archive','enterprise'],tier:['pro'], name:"Job Board", coming: true },
{tier_compare:['pro','pro_idle','premium','archive','enterprise'],tier:['pro'], name:"Public Facing Profile", coming: true },

{tier_compare:['premium','enterprise'],tier:['premium'], name:"Access to Production Suite", coming: false },
{tier_compare:['premium','enterprise'],tier:['premium'], name:"Feature and Episodic Projects", coming: false },
{tier_compare:['premium','enterprise'],tier:['premium'], name:"Team Management", coming: false },
{tier_compare:['premium','enterprise'],tier:['premium'], name:"Team Calendar", coming: false },
{tier_compare:['premium','enterprise'],tier:['premium'], name:"Production Memos", coming: false },
{tier_compare:['premium','enterprise'],tier:['premium'], name:"Script Breakdown", coming: false },
{tier_compare:['premium','enterprise'],tier:['premium'], name:"Scene Cards and Notes", coming: false },
{tier_compare:['premium','enterprise'],tier:['premium'], name:"Private Previz", coming: false },
{tier_compare:['premium','enterprise'],tier:['premium'], name:"Document Repository", coming: false },
{tier_compare:['premium','enterprise'],tier:['premium'], name:"Enhanced Workflow Security", coming: false },
{tier_compare:['premium','enterprise'],tier:['premium'], name:"Localization for Main Markets", coming: false },
{tier_compare:['premium','enterprise'],tier:['premium'], name:"Multi-role for Users", coming: false },
{tier_compare:['premium','enterprise'],tier:['premium'], name:"Access to Archives", coming: false },
{tier_compare:['premium','enterprise'],tier:['premium'], name:"Budget Assistant", coming: true },
{tier_compare:['premium','enterprise'],tier:['premium'], name:"Risk Assessments", coming: true },
{tier_compare:['premium','enterprise'],tier:['premium'], name:"Team managment", coming: true },


{tier_compare:['enterprise'],tier:['enterprise'], name:"All Department Head features", coming: false },
{tier_compare:['enterprise'],tier:['enterprise'], name:"Production Hubs", coming: false },
{tier_compare:['enterprise'],tier:['enterprise'], name:"User Groups", coming: false },
{tier_compare:['enterprise'],tier:['enterprise'], name:"Access Controls", coming: false },
{tier_compare:['enterprise'],tier:['enterprise'], name:"Reporting and Analytics", coming: true },
{tier_compare:['enterprise'],tier:['enterprise'], name:"Promotional Codes", coming: true },
{tier_compare:['enterprise'],tier:['enterprise'], name:"Dedicated account manager", coming: true },
{tier_compare:['enterprise'],tier:['enterprise'], name:"Custom integrations", coming: true },
{tier_compare:['enterprise'],tier:['enterprise'], name:"Priority support", coming: true },
]);
  const [showDowngradeModal, setshowDowngradeModal] = useState<MasterPlan|null>(null);
  const [showContactSaleModal, setshowContactSaleModal] = useState<MasterPlan|null>(null);
  useEffect(() => {
    console.log('UserPlansPage useEffect currentUser');
    getUserPlans();
  }, [currentUser]);


  const cancelPlanHandler = () => {
      let masterPlan  = getIdleCooridnatorMasterPlan(
        BillingCycle.month,
        SubscriptionTier.free
      );
      if(masterPlan) {
        setshowDowngradeModal(masterPlan);
      }
  }

  const getPlanTitle = (subscription_tier) => {
    console.log(masterPlans);
    const item: MasterPlan = masterPlans.find(
      (item) => item.subscription_tier == subscription_tier
    );
    if (item) {
      return item.plan_name;
    }
    return 'Basic';
  };
  const getUserPlans = async () => {
    try {
      const resp = await userService.getUserPlans();
      if (resp) {
        let _userPlans = [];
        if ('user_plans' in resp) {
          _userPlans = resp.user_plans;
        }
        setUserPlans(_userPlans);
        if ('master_plans' in resp) {
          // let masterTemp:MasterPlan = {
          //   stripe_url: '',
          //   stripe_product_id: '',
          //   subscription_tier: 'enterprise',
          //   plan_name: 'Enterprise*',
          //   description: 'Great for production companies to organize and grant access to production teams',
          //   amount: '',
          //   billing_cycle: BillingCycle.month,
          //   plan_tag: ''
          // };
          //  let masterTempYearly:MasterPlan = {
          //   stripe_url: '',
          //   stripe_product_id: '',
          //   subscription_tier: 'enterprise',
          //   plan_name: 'Enterprise*',
          //   description: 'Great for production companies to organize and grant access to production teams',
          //   amount: '',
          //   billing_cycle: BillingCycle.year,
          //   plan_tag: ''
          // };
          let finalMasterPlans = [...resp.master_plans];
          if (finalMasterPlans.length > 0) {
            setmasterPlanA(finalMasterPlans[0]);
            setcompareOptionA({
              id: finalMasterPlans[0].subscription_tier,
              name: finalMasterPlans[0].plan_name
            })
          }
          if (finalMasterPlans.length > 1) {
            setmasterPlanB(finalMasterPlans[1]);
            setcompareOptionB({
              id: finalMasterPlans[1].subscription_tier,
              name: finalMasterPlans[1].plan_name
            })
          }
          let trialPeriod = _userPlans.filter((item) => item.status == 1 && item.stripe_subscription_id == null);
          if (trialPeriod.length > 0 && currentUser.subscription_tier == SubscriptionTier.pro) {
            finalMasterPlans = finalMasterPlans.filter((item) => item.is_visible = 1);
            // remove pro non trial plan and add trial plan
          } else {
            finalMasterPlans = finalMasterPlans.filter((item) => item.is_visible = 1);
          }

          setMasterPlans(finalMasterPlans);
          // setMasterPlans([...resp.master_plans.filter((item) => item.subscription_tier !== SubscriptionTier.archive), ...[masterTemp] ]);
        }
        const contactSalesTiers = Object.values(SubscriptionTier).filter(tier => tier !== SubscriptionTier.premium);
        switch (contact_btn) {
          case 0:
            break;
          case 1:
            setshowSubscriptionTiersContactSales([SubscriptionTier.free, SubscriptionTier.pro, SubscriptionTier.archive]);
            // show price to pro
            break;
          case 2:
            // show price to basic
            setshowSubscriptionTiersContactSales([SubscriptionTier.free]);
            break;
          case 3:
            // show price to all
            setshowSubscriptionTiersContactSales(contactSalesTiers);
            break;
          case 4:
            // show price to free
            setshowSubscriptionTiersContactSales(contactSalesTiers.filter((item) => item != SubscriptionTier.enterprise));
            break;

          default:
            break;
        }
      }
    } catch (error) {
      showToast('Error while cancelling subscription.', 'danger');
    } finally {
    }
  };
  // const cancelCurrentPlanHandler = async () => {
  //   try {
  //     const resp = await userService.cancelSubscription();
  //     if (resp) {
  //       showToast('Cancelled your current subscription.', 'success');
  //       return;
  //     }
  //   } catch (error) {
  //     showToast('Error while cancelling subscription.', 'danger');
  //   } finally {
  //   }
  // };
  const getSubFromUserPlan = (stripe_product_id: string) => {
    try {
      const masterPlan = masterPlans.find((item) => item.stripe_product_id == stripe_product_id);
      return masterPlan ? masterPlan.subscription_tier : '';
    } catch (error) { }
    return '';
  };
  const getIdleCooridnatorMasterPlan = (_monthlyYearly: string, subscription_tier: string) => {
    const plans = masterPlans.filter((item2) => item2.subscription_tier == subscription_tier
      && item2.billing_cycle == _monthlyYearly);
    if (plans.length > 0) {
      return plans[0];
    }
    return null;
  };
  const getAmount = (masterPlan: MasterPlan, idleCoordinator: boolean) => {
    let amount = 0;
    let idle_amount = 0;
    let masterPlan_amount = masterPlan.amount;
    if (idleCoordinator) {
      let subscription_tier = '';
      if (masterPlan.subscription_tier == SubscriptionTier.pro) {
        subscription_tier = SubscriptionTier.pro_idle;
      } else if (masterPlan.subscription_tier == SubscriptionTier.free) {
        subscription_tier = SubscriptionTier.archive;
      }
      const masterIdleCord = getIdleCooridnatorMasterPlan(monthlyYearly, subscription_tier);
      if (masterIdleCord) {
        masterPlan_amount = "0";
        idle_amount = parseInt(masterIdleCord.amount);
      }
    }
    if (monthlyYearly == BillingCycle.month) {
      amount = parseInt(masterPlan_amount) + (idle_amount);
    } else {
      amount = Math.round(parseInt(masterPlan_amount) / 12) + Math.round(idle_amount / 12)
    }
    return amount;
  }

  const isPlanActive = (subscription_tier: string, stripe_product_id: string) => {
    if (userPlans.length <= 0 && subscription_tier == SubscriptionTier.free) {
      return true;
    }
    console.log('subscription_tier', subscription_tier, 'stripe_product_id', stripe_product_id);
    const _userPlansFiltered: UserPlan[] = userPlans.filter((item) => {
      if (isUndefinedNullEmpty(item?.stripe_subscription_id)) {
        return false;
      }
      return (
        masterPlans.filter((item2) => {
          return (
            item2.stripe_product_id == item.stripe_product_id &&
            subscription_tier == item2.subscription_tier &&
            stripe_product_id == item2.stripe_product_id 
          );
        }).length > 0
      );
    });
    if (_userPlansFiltered.length > 0) {
      return true;
    }
    return false;
  };
  const isPlanActiveButCancelled = (subscription_tier: string, stripe_product_id: string) => {
    if(userPlans.length <= 0 && subscription_tier == SubscriptionTier.free) {
      return false;
    }
    const activeOrCancelled: UserPlan[] = userPlans.filter((item) => {
      return (
        masterPlans.filter((item2) => {
          return (
            item2.stripe_product_id == item.stripe_product_id &&
            subscription_tier == item2.subscription_tier &&
            stripe_product_id == item2.stripe_product_id
          );
        }).length > 0
      );
    });
    console.log('activeOrCancelled', activeOrCancelled);
    if (activeOrCancelled.filter((item) => {
        console.log( 'isExpired', isExpired(item.end_date));
      return item.status == 2 && !isExpired(item.end_date)
    }).length > 0) {
      return true;
    }
    if (activeOrCancelled.filter((item) => item.status == 1).length > 0) {
      return false;
    }
    return false;
  };
  const RenderItem = ({ masterPlan }) => {
    const [idleCoordinator, setidleCoordinator] = useState<boolean>(
      ((currentUser.subscription_tier == SubscriptionTier.pro_idle && masterPlan.subscription_tier == SubscriptionTier.pro) ||
        currentUser.subscription_tier == SubscriptionTier.archive && masterPlan.subscription_tier == SubscriptionTier.free) ? true : false
    );
    const [content, setcontent] = useState((<></>))
    const [customPrice, setcustomPrice] = useState(false);
    const [masterPlanArchiveSelected, setmasterPlanArchiveSelected] = useState(null);
    const isSpecial =
      masterPlan.plan_tag != undefined && masterPlan.plan_tag != null && masterPlan.plan_tag != '' && masterPlan.subscription_tier != SubscriptionTier.premium;

    useEffect(() => {
      actionButtonRender();
    }, [idleCoordinator])

    const actionButtonRender = () => {
      let planActive = isPlanActive(masterPlan.subscription_tier, masterPlan.stripe_product_id);
      let planActiveButCancelled = isPlanActiveButCancelled(
        masterPlan.subscription_tier,
        masterPlan.stripe_product_id
      );
      console.log('idleCoordinator', idleCoordinator, 'planActive', planActive, 'planActiveButCancelled', planActiveButCancelled);
      let masterPlanArchive = null;
      if (
        idleCoordinator &&
        !planActive &&
        (masterPlan.subscription_tier == SubscriptionTier.free ||
          masterPlan.subscription_tier == SubscriptionTier.pro)
      ) {
        if (masterPlan.subscription_tier == SubscriptionTier.free) {
          masterPlanArchive = getIdleCooridnatorMasterPlan(
            masterPlan.billing_cycle,
            SubscriptionTier.archive
          );
        } else if (masterPlan.subscription_tier == SubscriptionTier.pro) {
          masterPlanArchive = getIdleCooridnatorMasterPlan(
            masterPlan.billing_cycle,
            SubscriptionTier.pro_idle
          );
        }
        planActive = isPlanActive(
          masterPlanArchive.subscription_tier,
          masterPlanArchive.stripe_product_id
        );
        if (planActive) {
          planActiveButCancelled = isPlanActiveButCancelled(
            masterPlanArchive.subscription_tier,
            masterPlanArchive.stripe_product_id
          );
          //   setidleCoordinator(true);
        } else {
          //   setidleCoordinator(false);
        }
      } else {
        if (!idleCoordinator && masterPlan.subscription_tier == SubscriptionTier.free && currentUser.subscription_tier == SubscriptionTier.free) {
          planActive = true;
          planActiveButCancelled = false;
        } else if (idleCoordinator && masterPlan.subscription_tier == SubscriptionTier.free && currentUser.subscription_tier == SubscriptionTier.free) {
          planActive = false;
          planActiveButCancelled = false;
          masterPlanArchive = getIdleCooridnatorMasterPlan(
            masterPlan.billing_cycle,
            SubscriptionTier.archive
          );
        } else if (idleCoordinator && masterPlan.subscription_tier == SubscriptionTier.pro && currentUser.subscription_tier == SubscriptionTier.pro) {
          planActive = false;
          planActiveButCancelled = false;
          masterPlanArchive = getIdleCooridnatorMasterPlan(
            masterPlan.billing_cycle,
            SubscriptionTier.pro_idle
          );
        } else if (idleCoordinator && masterPlan.subscription_tier == SubscriptionTier.free) {
          planActive = false;
          planActiveButCancelled = false;
          masterPlanArchive = getIdleCooridnatorMasterPlan(
            masterPlan.billing_cycle,
            SubscriptionTier.archive
          );
        } else if (idleCoordinator && masterPlan.subscription_tier == SubscriptionTier.pro) {
          planActive = false;
          planActiveButCancelled = false;
          masterPlanArchive = getIdleCooridnatorMasterPlan(
            masterPlan.billing_cycle,
            SubscriptionTier.pro_idle
          );
        }

      }
      const downGradeUserPlan = isDownGradeUserPlan(
        currentUser.subscription_tier,
        masterPlan.subscription_tier
      );
      let contentAction = <></>;
      if (planActive) {
        if (planActiveButCancelled) {
          contentAction = (
            <>
              {' '}
              <Button variant="secondary" className="py-4 px-6">
                You Cancelled Current Plan
              </Button>
            </>
          );
        } else {
          contentAction = (
            <div className="flex flex-row">
              <Button variant="secondary" className="py-4 px-6">
                <div className="w-4 h-4 text-gray-700">
                  <CheckIcon className="w-4 h-4" />
                </div>
                Your Current Plan
              </Button>
            </div>
          );
        }
      } else if (downGradeUserPlan
        && (showSubscriptionTiersContactSales.indexOf(masterPlan.subscription_tier) >= 0
          || (masterPlanArchive != null && showSubscriptionTiersContactSales.indexOf(masterPlanArchive.subscription_tier) >= 0))
      ) {
        contentAction = (
          <Button
            variant="primary"
            className="py-4 px-6"
            onClick={() => {
              if (idleCoordinator) {
                let masterPlanArchive = null;
                if (masterPlan.subscription_tier == SubscriptionTier.free) {
                  masterPlanArchive = getIdleCooridnatorMasterPlan(
                    masterPlan.billing_cycle,
                    SubscriptionTier.archive
                  );
                } else if (masterPlan.subscription_tier == SubscriptionTier.pro) {
                  masterPlanArchive = getIdleCooridnatorMasterPlan(
                    masterPlan.billing_cycle,
                    SubscriptionTier.pro_idle
                  );
                }
                if (masterPlanArchive) {
                  setshowDowngradeModal(masterPlanArchive);
                  return;
                }
              }
              setshowDowngradeModal(masterPlan);
            }}
          >
            Downgrade
          </Button>
        );
      } else if (showSubscriptionTiersContactSales.indexOf(masterPlanArchive ? masterPlanArchive.subscription_tier : masterPlan.subscription_tier) >= 0) {
        contentAction = (
          <>
            <Button
              variant="primary"
              className="py-4 px-6"
              onClick={() => {

                // let paymentUrl = `${masterPlan.stripe_url}?prefilled_email=${currentUser.email}`;
                let paymentUrl = `/users/manage_billing`;
                if (idleCoordinator) {
                  let masterPlanArchive = null;
                  if (masterPlan.subscription_tier == SubscriptionTier.free) {
                    masterPlanArchive = getIdleCooridnatorMasterPlan(
                      masterPlan.billing_cycle,
                      SubscriptionTier.archive
                    );
                  } else if (masterPlan.subscription_tier == SubscriptionTier.pro) {
                    masterPlanArchive = getIdleCooridnatorMasterPlan(
                      masterPlan.billing_cycle,
                      SubscriptionTier.pro_idle
                    );
                  }
                  if(masterPlanArchive) {
                    paymentUrl = `/users/manage_billing`;
                    // paymentUrl = `${masterPlanArchive.stripe_url}?prefilled_email=${currentUser.email}`;
                  }
                }
                // window.open(paymentUrl, '_blank');
                window.location.href = paymentUrl;
              }}
            >
              Get Membership
            </Button>
          </>
        );
      } else {
        setcustomPrice(true);
        contentAction = (
          <>
            <Button variant="primary" className="py-4 px-6"
              onClick={() => {
                setshowContactSaleModal(masterPlanArchive ? masterPlanArchive : masterPlan);
              }}>
              Contact Sales
            </Button>
          </>
        );
      }
      setmasterPlanArchiveSelected(masterPlanArchive);
      setcontent(contentAction);
    };
    return (
      <div
        key={masterPlan.stripe_product_id}
        className={
          'flex flex-1 w-full sm:max-w-64-1  flex-col gap-5 justify-start items-start ' +
          (isSpecial ? ' py-0  ' : ' py-2 ')
        }
      >
        <div
          className={
            'flex flex-1 relative w-full sm:max-w-64-1 rounded-2xl-1 flex-col gap-5 justify-start items-start border-2 rounded-2xl  ' +
            (isSpecial
              ? ' py-0 bg-gray-100 border-blue-402 box-shadow-0-2-4-2-25 '
              : ' py-2 border bg-white box-shadow-100 ')
          }
        >
          {isSpecial && (
            <div className="absolute top-0 flex flex-row  items-center px-4 w-full justify-center">
              <div className="flex py-2 px-7 rounded-b-3xl border border-blue-402 bg-blue-402-30 text-gray-500">
                {masterPlan.plan_tag}
              </div>
            </div>
          )}
          <div
            className={
              'flex flex-col ' +
              (
                // Mobile + Special + not free/pro -> gap-6
                (isMobile &&
                  isSpecial &&
                  !(masterPlan.subscription_tier === SubscriptionTier.free ||
                    masterPlan.subscription_tier === SubscriptionTier.pro))
                  ? 'gap-0'
                  : (
                    // Mobile + not free/pro -> gap-0
                    (isMobile &&
                      !(masterPlan.subscription_tier === SubscriptionTier.free ||
                        masterPlan.subscription_tier === SubscriptionTier.pro))
                      ? 'gap-0'
                      : (
                        // Desktop → gap-16
                        !isMobile
                          ? 'gap-16'
                          // Default mobile → gap-6
                          : 'gap-6'
                      )
                  )
              ) +
              ' justify-start items-start px-8 ' +
              (isSpecial ? ' py-14' : ' py-10')
            }
          >

            <div
              className="flex flex-col gap-2-1 justify-between sm:h-28"
              style={{
                minHeight: '12rem',
              }}
            >
              <div className="flex flex-col gap-1">
                <div className="flex flex-col gap-1 h-24">
                  <div className="flex flex-col text-3xl font-light">{masterPlan.plan_name}</div>
                  {(masterPlan.subscription_tier == SubscriptionTier.free ||
                    masterPlan.subscription_tier == SubscriptionTier.pro ||
                    masterPlan.subscription_tier == SubscriptionTier.pro_idle) && (
                      <div className="flex flex-col text-13 font-bold">For Talent</div>
                    )}
                  {(masterPlan.subscription_tier == SubscriptionTier.premium) && (
                    <div className="flex flex-col text-13 font-bold">For Coordinators</div>
                  )}

                </div>
                <div className="flex flex-col text-sm font-normal h-20">{masterPlan.description}</div>
              </div>
              {/* addon start */}
              {(masterPlan.subscription_tier == SubscriptionTier.free ||
                masterPlan.subscription_tier == SubscriptionTier.pro) &&
                <div className='flex flex-row rounded-xl px-4 py-2-1 gap-2 bg-gray-50 border-blue-402 border'>
                  <div className='flex flex-row items-center gap-2 order-0 flex-grow'>
                    <div className='flex flex-row items-center'>
                      <Switch
                        checked={idleCoordinator}
                        onChange={() => {
                          setidleCoordinator(!idleCoordinator);
                        }}
                        className={twMerge(
                          'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2',
                          idleCoordinator ? 'bg-blue-500' : 'bg-gray-200'
                        )}
                      >
                        <span className="sr-only">Use setting</span>
                        <span
                          aria-hidden="true"
                          className={twMerge(
                            'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out',
                            idleCoordinator ? 'translate-x-5' : 'translate-x-0'
                          )}
                        />
                      </Switch>
                    </div>
                    <div className='justify-center pb-2 gap-2-1 border-l-1 border-gray-300 order-1 flex-grow font-semibold text-xs'></div>
                    Add Idle Coordinator
                  </div>
                  <div className='flex flex-row items-center text-blue-500 relative'>
                    <Tooltip
                      width=" w-80 "
                      width_height_icon="w-4-2 h-4-2"
                      message="The <strong>Idle Coordinator</strong> add-on allows Department Heads to temporarily downgrade their membership to Basic or Pro while retaining access to an archive of their past projects—ideal for downtime between productions."
                    />

                  </div>
                </div>
              }
              {/* addon start */}
            </div>
            <div className="flex flex-col gap-5 w-full">
              <div className="flex flex-row gap-1" style={{
                minHeight: '4.25rem'
              }}>
                {showSubscriptionTiersContactSales.indexOf(masterPlanArchiveSelected ? masterPlanArchiveSelected.subscription_tier : masterPlan.subscription_tier) >= 0 && (
                  <div className="flex flex-col text-3xl font-semibold items-end justify-end">$</div>
                )}
                {showSubscriptionTiersContactSales.indexOf(masterPlanArchiveSelected ? masterPlanArchiveSelected.subscription_tier : masterPlan.subscription_tier) >= 0 ? (
                  <>
                    <div className="flex flex-col text-7xl font-bold items-end justify-end" style={{
                      lineHeight: 0.75,
                      letterSpacing: '-0.06em',
                    }}>
                      {getAmount(masterPlan, idleCoordinator)}
                    </div>
                    <div className="flex flex-col flex flex-col items-start justify-end">
                      <div className="text-sm font-normal">/month</div>
                      {masterPlan.billing_cycle == 'year' && <div className="text-xs font-normal">billed {masterPlan.billing_cycle}ly</div>}
                    </div>
                  </>
                ) : (
                  <>
                    <div className="flex flex-col font-bold items-start justify-start">
                      <div className="text-xl font-bold">Custom</div>
                      <div className="text-4xl font-bold">Pricing</div>
                    </div>
                  </>
                )}
              </div>
              {showSubscriptionTiersContactSales.indexOf(masterPlanArchiveSelected ? masterPlanArchiveSelected.subscription_tier : masterPlan.subscription_tier) >= 0 ? (
                <div className="flex flex-col ">
                  {content}
                </div>
              ) : (
                <>
                  <div className="flex flex-col ">
                    <Button variant="primary" className="py-4 px-6"
                      onClick={() => {
                        setshowContactSaleModal(masterPlan);
                      }}>
                      Contact Sales
                    </Button>
                  </div>
                </>
              )}
            </div>
            <div className="w-full flex flex-col gap-4 pt-8 border-t">
              <div
                className="flex flex-row gap-2 font-semibold justify-center sm:justify-start"
                onClick={() => {
                  if (masterPlan.stripe_product_id == expandKeyFeature) {
                    setExpandKeyFeature('');
                  } else {
                    setExpandKeyFeature(masterPlan.stripe_product_id);
                  }
                }}
              >
                <div className=" flex sm:hidden">
                  <svg
                    className={`
                              w-4 h-4 transform transition-transform duration-200
                              ${masterPlan.stripe_product_id == expandKeyFeature ? 'rotate-180' : 'rotate-0'}
                            `}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"
                    ></path>
                  </svg>
                </div>
                Key Features:
              </div>
              <div
                className={
                  masterPlan.stripe_product_id == expandKeyFeature
                    ? ' flex flex-col gap-4 '
                    : ' hidden sm:flex sm:flex-col gap-4'
                }
              >
                {featuresNames
                  .filter((item) => {
                    return item.tier.indexOf(masterPlan.subscription_tier) >= 0 && item.coming == false;
                  })
                  .map((item, index) => {
                    return (
                      <>
                        <div className="flex flex-row items-start p-0 gap-4" key={index}>
                          <div className="w-6 h-6 text-blue-500">
                            <CircleCheckBigIcon className="w-6 h-6 " />
                          </div>
                          <div className="flex flex-row items-start text-sm font-normal">
                            {item.name}
                          </div>
                        </div>
                      </>
                    );
                  })}
              </div>
            </div>
            {featuresNames
              .filter((item) => {
                return item.tier.indexOf(masterPlan.subscription_tier) >= 0 && item.coming == true;
              }).length > 0 && <div className="w-full flex flex-col gap-4 pt-8 border-t">
                <div
                  className="flex flex-row gap-2 font-semibold justify-center sm:justify-start"
                  onClick={() => {
                    if (masterPlan.stripe_product_id == expandComing) {
                      setExpandComing('');
                    } else {
                      setExpandComing(masterPlan.stripe_product_id);
                    }
                  }}
                >
                  <div className=" flex sm:hidden">
                    <svg
                      className={`
                              w-4 h-4 transform transition-transform duration-200
                              ${masterPlan.stripe_product_id == expandComing ? 'rotate-180' : 'rotate-0'}
                            `}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M19 9l-7 7-7-7"
                      ></path>
                    </svg>
                  </div>
                  Coming to Filmik:
                </div>
                <div
                  className={
                    masterPlan.stripe_product_id == expandComing
                      ? ' flex flex-col gap-4 '
                      : ' hidden sm:flex sm:flex-col gap-4'
                  }
                >
                  {featuresNames
                    .filter((item) => {
                      return item.tier.indexOf(masterPlan.subscription_tier) >= 0 && item.coming == true;
                    })
                    .map((item, index) => {
                      return (
                        <>
                          <div className="flex flex-row items-start p-0 gap-4" key={index}>
                            <div className="w-6 h-6 text-gray-400">
                              <ClockFadingIcon className="w-6 h-6 " />
                            </div>
                            <div className="flex flex-row items-start text-sm font-normal">
                              {item.name}
                            </div>
                          </div>
                        </>
                      );
                    })}
                </div>
              </div>}
          </div>
        </div>
      </div>
    );
  };
  const targetDivRef = useRef(null);

    const scrollToTarget = () => {
      if (targetDivRef.current) {
        // Use the native DOM API to scroll the element into the viewport
        targetDivRef.current.scrollIntoView({
          behavior: 'smooth', // Optional: for a smooth scrolling animation
          block: 'start',     // Optional: aligns the element's start (top) with the viewport's start
        });
      }
    };
  return (
    <div className="w-full flex flex-col flex-1 mx-auto pb-1 bg-gray-50">
      {showDowngradeModal == null && (
        <>
          <Breadcrumb2
            pages={[
              { name: 'Membership', href: '#', current: false },
              { name: 'Choose Your Plan', href: '#', current: true },
            ]}
          ></Breadcrumb2>
          <div className="w-full flex flex-col flex-1 mx-auto pb-1 bg-gray-50 px-4 sm:px-6 lg:px-8 ">
            {userPlans.length > 0 && (
              <div className="flex flex-row  items-center px-4 w-full justify-center">
                <div className="flex flex-col sm:flex-row py-2 px-7 rounded-b-3xl border border-blue-402 bg-blue-402-30 text-gray-500 text-xs gap-1-1">
                  <div className="flex  text-gray-500 justify-center">
                    <div className="">You are on the&nbsp;</div>{' '}
                    <div className="font-semibold text-gray-900">
                      {getPlanTitle(currentUser.subscription_tier)}
                    </div>{' '}
                    <div className="">&nbsp; Plan</div>{' '}
                  </div>
                  <div className="hidden sm:flex justify-center items-center ">
                    <div className="font-semibold flex justify-center items-center text-gray-900 bg-gray-500 w-1 h-1 rounded-full">&nbsp;</div>
                  </div>
                  <div className="flex  text-gray-500 justify-center">
                    <div className="">Started on&nbsp;</div>{' '}
                    <div className="font-semibold text-gray-900">
                      {new Date(userPlans[0].start_date).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                      })}
                    </div>
                  </div>
                  <div className="hidden sm:flex justify-center items-center ">
                    <div className="font-semibold flex justify-center items-center text-gray-900 bg-gray-500 w-1 h-1 rounded-full">&nbsp;</div>
                  </div>
                  <div className="flex  text-gray-500 justify-center">
                    <div className="">Auto-renews on&nbsp;</div>{' '}
                    <div className="font-semibold text-gray-900">
                      {new Date(userPlans[0].end_date).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                      })}
                    </div>
                  </div>
                  { <>
                  <div className="hidden sm:flex justify-center items-center ">
                    <div className="font-semibold flex justify-center items-center text-gray-900 bg-gray-500 w-1 h-1 rounded-full">&nbsp;</div>
                  </div>
                  <div className="flex  text-gray-500 justify-center">
                    <div className="cursor-pointer" onClick={()=>{
                      cancelPlanHandler();
                    }} >Cancel Plan&nbsp;</div>
                  </div>
                  </>}
                </div>
              </div>
            )}
            <div className="w-full max-w-6xl mx-auto relative py-14">
              <div className="flex flex-col pt-2 sm:px-48 gap-8 justify-center items-center">
                <div className="font-semibold text-4xl sm:text-5xl justify-center items-center">
                  CHOOSE YOUR PLAN
                </div>
                <div className="font-light text-2xl justify-center items-center text-center">
                  Unlock new ways to create, collaborate, and grow with tiers designed to elevate
                  your journey on Filmik. Your goals, your pace, your path. <span className='font-semibold'>Upgrade Your Experience!</span>
                </div>
                  <div className="gap-2-1 justify-center items-center">
                 <div className="bg-blue-402-30 flex flex-row items-center p-1 rounded-full">
                    <div
                      className={
                        'cursor-pointer flex flex-row justify-center items-center py-2 px-8 gap-2-1 ' +
                        (monthlyYearly == BillingCycle.month
                          ? 'bg-white border-blue-402 rounded-full'
                          : '')
                      }
                      onClick={() => {
                        setmonthlyYearly(BillingCycle.month);
                      }}
                    >
                      <div className="font-semibold text-gray-500 text-13">Monthly Billing</div>
                    </div>
                    <div
                      className={
                        'cursor-pointer flex flex-row justify-center items-center py-2 px-8 gap-2-1 ' +
                        (monthlyYearly == BillingCycle.year
                          ? 'bg-white border-blue-402 rounded-full'
                          : '')
                      }
                      onClick={() => {
                        setmonthlyYearly(BillingCycle.year);
                      }}
                    >
                      <div className="font-semibold text-gray-900 text-13">Yearly Billing</div>
                    </div>
                  </div>
                </div>
                <div className="font-medium text-blue-500 text-sm justify-center items-center cursor-pointer"
                  onClick={() => {
                    scrollToTarget();
                  }}>
                  Compare All Plan Details
                </div>
              </div>
              <div className="flex flex-col py-8 sm:flex-row gap-5 justify-start items-center sm:items-start overflow-x-scroll scrollable-content">
                {/* item start */}
                {masterPlans
                  .filter(
                    (item) =>
                      item.subscription_tier != SubscriptionTier.pro_idle &&
                      item.subscription_tier != SubscriptionTier.archive &&
                      item.is_visible == 1 &&
                      item.billing_cycle == monthlyYearly
                  )
                  .map((masterPlan) => {
                    return (
                      <>
                        <RenderItem masterPlan={masterPlan} />
                        {/* {renderItem(masterPlan)} */}
                        {/* <PlanCard masterPlan={masterPlan} currentUser={currentUser} userPlans={userPlans} masterPlans={masterPlans}
                    /> */}
                      </>
                    );
                  })}
                { }
                {/* item end */}
              </div>
              {false && userPlans.length > 0 && (
                <></>
                // <div className="bg-white p-8 rounded-lg shadow-md">
                //   <h2 className="text-3xl font-bold text-gray-800 mb-4">
                //     Current Plan: {getPlanTitle(currentUser.subscription_tier)}
                //   </h2>
                //   <div className="text-gray-600 space-y-2">
                //     <p>
                //       <span className="font-semibold">Start Date:</span>{' '}
                //       {new Date(userPlans[0].start_date).toLocaleDateString('en-US', {
                //         year: 'numeric',
                //         month: 'long',
                //         day: 'numeric',
                //       })}
                //     </p>
                //     <p>
                //       <span className="font-semibold">End Date:</span>{' '}
                //       {new Date(userPlans[0].end_date).toLocaleDateString('en-US', {
                //         year: 'numeric',
                //         month: 'long',
                //         day: 'numeric',
                //       })}
                //     </p>
                //   </div>
                //   {userPlans[0].status == 2 && (
                //     <div className="text-gray-600 space-y-2">
                //       <h5 className="text-sm text-gray-400">
                //         Plan is already cancelled, it will be valid till end of period
                //       </h5>
                //     </div>
                //   )}
                //   {userPlans[0].status == 1 && (
                //     <div className="text-gray-600 space-y-2">
                //       <button
                //         onClick={cancelCurrentPlanHandler}
                //         className="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 cursor-pointer ml-3"
                //       >
                //         Cancel Plan
                //       </button>
                //       <h5 className="text-sm text-gray-400">
                //         Plan will get cancel at end of period.
                //       </h5>
                //     </div>
                //   )}
                // </div>
              )}
              {false && userPlans.length == 0 && (
                <></>
                // <div className="bg-white p-8 rounded-lg shadow-md">
                //   <h2 className="text-3xl font-bold text-gray-800 mb-4">
                //     Current Plan: {getPlanTitle(SubscriptionTier.free)}
                //   </h2>
                // </div>
              )}
              {false &&
                (userPlans.length == 0 ||
                  (userPlans.length > 0 &&
                    getSubFromUserPlan(userPlans[0].stripe_product_id) !==
                      SubscriptionTier.premium)) && (
                  <></>
                  // <div className="min-h-screen py-10 px-4">
                  //   <div className=" mx-auto">
                  //     <div className="text-center mb-10">
                  //       <h1 className="text-4xl font-extrabold text-gray-900 mb-2">
                  //         Choose Your Plan
                  //       </h1>
                  //       <p className="text-lg text-gray-500">
                  //         Select the perfect plan for you, it will be activated immediately
                  //       </p>
                  //     </div>

                  //     {/* Responsive grid for the plan boxes */}
                  //     <div className="grid grid-cols-1 gap-6 md:grid-cols-3 lg:grid-cols-3">
                  //       {masterPlans.map((masterPlan) => {
                  //         // The key prop is important for React to efficiently render lists
                  //         if (
                  //           userPlans &&
                  //           userPlans.length > 0 &&
                  //           getSubFromUserPlan(userPlans[0].stripe_product_id) ==
                  //             SubscriptionTier.premium
                  //         ) {
                  //           return <></>;
                  //         }
                  //         return (
                  //           <></>
                  //           // <PlanCard
                  //           //   key={masterPlan.stripe_product_id}
                  //           //   masterPlan={masterPlan}
                  //           //   currentUser={currentUser}
                  //           // />
                  //         );
                  //       })}
                  //     </div>
                  //   </div>
                  // </div>
                )}
            </div>{' '}
            {/* compare */}
            <div className="w-full max-w-6xl mx-auto relative gap-8 flex flex-col">
              <div className="pt-10 px-2 sm:px-48 gap-8"
                ref={targetDivRef}
              >
                <div className="w-full items-center justify-center font-semibold text-center sm:text-center " style={{
                  fontSize: '3rem'
                }}>
                  Compare Plans
                </div>
                <div className="w-full items-center justify-center font-lite text-center sm:text-center " style={{
                  
                }}>
                  FILMIK offers flexible membership tiers for every stage of production.
                  The <strong>Basic</strong> plan provides essential access to talent profiles and media.
                  <strong> Pro for Talent</strong> unlocks professional tools with upgraded media uploads and display formats.
                  <strong> Department Heads</strong> gain full production management capabilities, 
                  while <strong>Enterprise</strong> delivers advanced integrations, reporting, and dedicated support for large-scale teams.
                </div>
              </div>
              {masterPlans.length > 0 && compareOptionA && (
                <div className="flex flex-col w-full sm:hidden gap-2-1">
                  <div className="flex flex-row w-full gap-2-1">
                    <div className="flex justify-center items-center">A</div>
                    <div className="flex flex-1  justify-center items-center">
                      <SelectList
                        id="a_user_plan_compare_id"
                        options={masterPlans
                          .filter((item) => item.billing_cycle == BillingCycle.month
                            && item.subscription_tier != SubscriptionTier.archive
                            && item.subscription_tier != SubscriptionTier.free
                            && item.subscription_tier != SubscriptionTier.pro_idle
                            && item.is_visible == 1
                            && compareOptionB.id !== item.subscription_tier)
                          .map((item) => {
                            let option: OptionProps = {
                              id: item.subscription_tier,
                              name: item.plan_name,
                            };
                            return option;
                          })}
                        initialValue={compareOptionA}
                        onChange={function (value: OptionProps): void {
                          console.log('value', value);
                          const plans = masterPlans.filter(
                            (item) =>
                              item.billing_cycle == BillingCycle.month &&
                              item.subscription_tier == value.id
                          );
                          if (plans.length > 0) {
                            setmasterPlanA(plans[0]);
                            setcompareOptionA(value);
                          }
                        }}
                      ></SelectList>
                      {/* <SelectCombobox
                        id="a_user_plan_compare_id"
                        options={masterPlans
                          .filter((item) => item.billing_cycle == BillingCycle.month 
                            && item.subscription_tier != SubscriptionTier.archive
                            && item.subscription_tier != SubscriptionTier.free
                            && item.subscription_tier != SubscriptionTier.pro_idle
                          && compareOptionB.id !== item.subscription_tier)
                          .map((item) => {
                            let option: OptionProps = {
                              id: item.subscription_tier,
                              name: item.plan_name,
                            };
                            return option;
                          })}
                        initialValue={compareOptionA}
                        onChange={function (value: OptionProps): void {
                          const plans = masterPlans.filter(
                            (item) =>
                              item.billing_cycle == BillingCycle.month &&
                              item.subscription_tier == value.id
                          );
                          if (plans.length > 0) {
                            setmasterPlanA(plans[0]);
                            setcompareOptionA(value);
                          }
                        }}
                      ></SelectCombobox> */}
                    </div>
                  </div>
                  <div className="flex flex-row w-full gap-2-1">
                    <div className="flex justify-center items-center">B</div>
                    <div className="flex flex-1  justify-center items-center">
                      <SelectList
                        id="a_user_plan_compare_id"
                        options={masterPlans
                          .filter((item) => item.billing_cycle == BillingCycle.month
                            && item.subscription_tier != SubscriptionTier.archive
                            && item.subscription_tier != SubscriptionTier.free
                            && item.subscription_tier != SubscriptionTier.pro_idle
                            && item.is_visible == 1
                            && compareOptionA.id !== item.subscription_tier)
                          .map((item) => {
                            let option: OptionProps = {
                              id: item.subscription_tier,
                              name: item.plan_name,
                            };
                            return option;
                          })}
                        initialValue={compareOptionB}
                        onChange={function (value: OptionProps): void {
                          const plans = masterPlans.filter(
                            (item) =>
                              item.billing_cycle == BillingCycle.month &&
                              item.subscription_tier == value.id
                          );
                          if (plans.length > 0) {
                            setmasterPlanB(plans[0]);
                            setcompareOptionB(value);
                          }
                        }}
                      ></SelectList>
                    </div>
                  </div>
                </div>
              )}
              <div
                className="flex flex-row items-start  w-full"
                style={{
                  padding: '0px 0px 20px',
                  // borderBottom: '1px solid #D1D5DB',
                }}
              >
                <div className="flex flex-row w-full pt-8 sm:flex-row justify-center items-start sm:overflow-x-scroll sm:scrollable-content">
                  {(isMobile && masterPlanB != null ? [masterPlanA, masterPlanB] : masterPlans)
                    .filter(
                      (item) =>
                        item.subscription_tier != SubscriptionTier.pro_idle &&
                        item.subscription_tier != SubscriptionTier.archive &&
                        item.is_visible == 1 &&
                        item.billing_cycle == 'month'
                    )
                    .map((masterPlan, index) => {
                      let content = <></>;
                      if (index == 0) {
                        content = (
                          <>
                            <div
                              key={masterPlan.stripe_product_id}
                              className={
                                'flex flex-1  sm:max-w-64-1  flex-col justify-start items-start '
                              }
                              style={{
                                maxWidth: isMobile ? '8rem' : 'none',
                                flex: 'none',
                                order: 0,
                                alignSelf: 'stretch',
                                flexGrow: 0,
                              }}
                            >
                              <div
                                className={
                                  'flex flex-1 relative sm:max-w-64-1 rounded-2xl-1 flex-col gap-5 justify-start items-start py-2  '
                                }
                              >
                                <div
                                  className={
                                    'flex flex-col gap-10 justify-start items-start py-10 w-full'
                                  }
                                >
                                  <div
                                    className="flex flex-col gap-2-1 w-full"
                                    style={{
                                      minHeight: '3rem',
                                    }}
                                  >
                                    <div className="flex flex-col gap-1 w-full h-4">&nbsp;</div>
                                  </div>

                                  <div className=" w-full flex flex-col gap-4 pt-8 border-t ">
                                    <div className={'flex flex-col gap-4'}>
                                      {featuresNames.map((item, index) => {
                                        return (
                                          <>
                                            <div
                                              className="flex flex-row  w-full p-0 gap-4 items-center"
                                              key={index}
                                              style={{
                                                minWidth: isMobile ? '8rem' : '14rem',
                                                minHeight: isMobile ? '3.75rem' : '1.875rem',
                                              }}
                                            >
                                              <div className="flex flex-row items-start text-sm font-normal ">
                                                {item.name}
                                                {item.coming ? ' *' : ''}
                                              </div>
                                            </div>
                                          </>
                                        );
                                      })}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      }
                      return (
                        <>
                          {content}
                          <div
                            key={masterPlan.stripe_product_id}
                            className={'flex flex-1 flex-col justify-start items-center'}
                            style={{
                              flex: 'none',
                              order: index + 1,
                              alignSelf: 'stretch',
                              flexGrow: 1,
                              maxWidth: '8.125rem'
                            }}
                          >
                            <div
                              className={
                                'flex flex-1 relative rounded-2xl-1 flex-col gap-5 justify-start items-center w-full py-2'
                              }
                            >
                              <div
                                className={
                                  'flex flex-col gap-10 justify-start items-start py-10 w-full'
                                }
                              >
                                <div
                                  className="flex flex-col gap-2-1 w-full"
                                  style={{
                                    minHeight: '3rem',
                                  }}
                                >
                                  <div className="flex flex-col gap-1 w-full h-4">
                                    <div className="flex flex-col text-lg font-bold text-center break-all">
                                      {masterPlan.plan_name}
                                    </div>
                                    {(masterPlan.subscription_tier == SubscriptionTier.free ||
                                      masterPlan.subscription_tier == SubscriptionTier.pro ||
                                      masterPlan.subscription_tier ==
                                      SubscriptionTier.pro_idle) && (
                                        <div className="flex flex-col text-xs font-normal text-center text-gray-500 break-all">
                                          For Talent
                                        </div>
                                      )}
                                    {(masterPlan.subscription_tier == SubscriptionTier.premium) && (
                                      <div className="flex flex-col text-xs font-normal text-center text-gray-500 break-all">
                                        For Coordinators
                                      </div>
                                    )}
                                    {(masterPlan.subscription_tier == SubscriptionTier.enterprise) && (
                                      <div className="flex flex-col text-xs font-normal text-center text-gray-500 break-all">
                                        For Production Companies
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="w-full flex flex-col gap-4 pt-8 border-t  items-center justify-start">
                                  <div className={'flex flex-col gap-4'}>
                                    {featuresNames.map((item, index) => {
                                      const isAvailable =
                                        item.tier_compare.indexOf(masterPlan.subscription_tier) >= 0;

                                      return (
                                        <div
                                          className="flex flex-row w-full items-center justify-center p-0 gap-4"
                                          key={index}
                                          style={{
                                            minWidth: isMobile ? '8rem' : '14rem',
                                            minHeight: isMobile ? '3.75rem' : '1.875rem',
                                          }}
                                        >
                                          {isAvailable ? (
                                            <div className="w-6 h-6 text-blue-500">
                                              <CheckIcon className="w-6 h-6" />
                                            </div>
                                          ) : (
                                            <div className="w-6 h-6 text-gray-300">
                                              <Minus className="w-6 h-6" />
                                            </div>
                                          )}
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>
                        </>
                      );
                    })}
                </div>
              </div>
              <div
                className="flex flex-row items-start gap-4  w-full pt-4 pb-10 text-xs font-normal"
                style={{
                  // borderTop: '1px solid #D1D5DB',
                }}
              >
                <div>*</div>
                <div>Coming features.</div>
              </div>
            </div>
          </div>
        </>
      )}
      {showDowngradeModal != null && (
        <>
          <DowngradePlanPage
            currentUser={currentUser}
            user_plans={userPlans}
            master_plans={masterPlans}
            is_pro_trial={is_pro_trial}
            is_premium_trial={is_premium_trial}
            masterPlan={showDowngradeModal}
            closeDowngradePlanPage={function (): void {
              setshowDowngradeModal(null);
            }}
          />
        </>
      )}
       {showContactSaleModal != null && (
        <>
          <ContactSales
            isOpen={showContactSaleModal != null}
            currentUser={currentUser}
            masterPlan={showContactSaleModal}
            onNoteAdded={function (): void {
              setshowContactSaleModal(null);
            }}
            onClose={function (): void {
              setshowContactSaleModal(null);
            }}
          />
        </>
      )}
    </div>
  );
}
